























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

const defaultBackgroundColor: string = "rgba(0, 0, 0, 0.5)";
const percent: number = 0.8;
let sizeChecker: number = 0;

@Component
export default class ElPreviewer extends Vue {
	@Prop({ type: Number, default: 1 }) zIndex!: number;
	@Prop({
		type: Array,
		default() {
			return [];
		}
	})
	src!: Array<string>;
	@Prop({ type: [String, Object], default: defaultBackgroundColor })
	background!: string;
	@Prop() sourceDom!: any;
	@Prop({ type: String, default: "pointer" }) cursor!: string;
	@Prop({
		type: Object,
		default() {
			return { duration: 100 };
		}
	})
	animate!: any;
	@Prop({ type: [String, Number] }) maxWidth!: number | string;
	@Prop({ type: [String, Number] }) maxHeight!: number | string;
	@Prop({ type: [String, Number] }) previewSize!: number | string;

	isShow: boolean = false;
	pictureSize: any = {};
	imgStyle: any = {};
	key: string = `image-previewer-${new Date().getTime()}`;
	status: string = "";

	get bgStyle() {
		let backgroundStyle =
			typeof this.background === "string"
				? {
						backgroundColor: this.background
				  }
				: {
						backgroundColor: defaultBackgroundColor,
						...(this.background as any)
				  };
		backgroundStyle.transition = this.handleTransition(this.animate);
		return { opacity: this.isShow ? "1" : "0", ...backgroundStyle };
	}
	get maxWidthComputed() {
		const windowWidth = window.innerWidth;
		let result: any;
		switch (typeof this.maxWidth) {
			case "number":
				result = this.maxWidth || windowWidth * percent;
				break;
			case "string":
				result = /\d+%$/.test(this.maxWidth)
					? (parseFloat(this.maxWidth) / 100) * windowWidth
					: parseFloat(this.maxWidth);
				result = result || windowWidth * percent;
				break;
			default:
				result = windowWidth * percent;
		}
		if (typeof this.previewSize !== "undefined") {
			result = Math.min(
				result,
				Number(this.previewSize) * this.pictureSize.width
			);
		}
		return result;
	}
	get maxHeightComputed() {
		const windowHeight = window.innerHeight;
		let result: any;
		switch (typeof this.maxHeight) {
			case "number":
				result = this.maxHeight || windowHeight * percent;
				break;
			case "string":
				result = /\d+%$/.test(this.maxHeight)
					? (parseFloat(this.maxHeight) / 100) * windowHeight
					: parseFloat(this.maxHeight);
				result = result || windowHeight * percent;
				break;
			default:
				result = windowHeight * percent;
		}
		if (typeof this.previewSize !== "undefined") {
			result = Math.min(
				result,
				Number(this.previewSize) * this.pictureSize.height
			);
		}
		return result;
	}

	@Watch("pictureSize", { deep: true })
	onPictureSizeWatch(val: any) {
		["top", "left", "width", "height"].forEach(key => {
			this.$set(this.imgStyle, key, val[key] + "px");
		});
		this.$set(this.imgStyle, "transition", this.handleTransition(this.animate));
		this.$set(this.imgStyle, "cursor", this.cursor);
	}
	@Watch("cursor")
	onCursorWatch(val: any) {
		this.imgStyle.cursor = val;
	}

	created() {
		this.imgStyle.cursor = this.cursor;
	}
	mounted() {
		window.addEventListener("resize", this.setPictureSize);
	}
	destroyed() {
		clearInterval(sizeChecker);
		window.removeEventListener("resize", this.setPictureSize);
	}

	close() {
		clearInterval(sizeChecker);
		this.setPictureBegin();
		this.isShow = false;
		setTimeout(() => {
			this.$emit("close");
		}, this.animate.duration + this.animate.delay);
	}
	open() {
		this.isShow = true;
		this.setPictureSize();
	}
	handleTransition({
		duration,
		delay,
		func
	}: {
		duration: number;
		delay: number;
		func: any;
	}) {
		return `${duration || 0}ms ${delay || 0}ms ${func || ""}`;
	}
	setPictureSize() {
		let result = { width: 0, height: 0, top: 0, left: 0 };
		let picture = this.$refs.picture;
		let naturalWidth = (picture as any).naturalWidth;
		let naturalHeight = (picture as any).naturalHeight;
		clearInterval(sizeChecker);
		sizeChecker = setInterval(() => {
			if ((picture as any).naturalWidth && (picture as any).naturalHeight) {
				naturalWidth = (picture as any).naturalWidth;
				naturalHeight = (picture as any).naturalHeight;
				clearInterval(sizeChecker);

				//获取到尺寸后再显示;
				let pictureRatio = naturalWidth / naturalHeight;
				let windowRatio = window.innerWidth / window.innerHeight;
				if (pictureRatio >= windowRatio) {
					let width = this.maxWidthComputed;
					result.width = parseInt(width);
					result.height = parseInt(String(width / pictureRatio));
				} else {
					let height = this.maxHeightComputed;
					result.height = parseInt(height);
					result.width = parseInt(String(height * pictureRatio));
				}
				result.top = (window.innerHeight - parseInt(String(result.height))) / 2;
				result.left = (window.innerWidth - parseInt(String(result.width))) / 2;
				this.pictureSize = result;
			}
		}, 10);
	}
	setPictureBegin() {
		let rect = this.sourceDom.getBoundingClientRect();
		let { width, height, top, left } = rect;
		this.pictureSize = { width: width, height: height, top: top, left: left };
	}
}
